import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { Button } from "../_components/button.component";
import { OrganizationService } from "../_service/organization.service";
import { TextInput } from "../_components/text-input.component";
import Timezones from "../_config/timezones.config.json";
import continents from "../_config/country-codes.config.json";
import uploadIcon from "../_assets/images/upload.png";
import galleryIcon from "../_assets/images/gallery.png";
import closeIcon from "../_assets/images/close.png";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import { Controller, useForm } from "react-hook-form";
import { CommunityService } from "../_service/community-management.service";
import { useParams } from "react-router";
import leftIcon from "../_assets/images/left_icon.png";
import trashIcon from "../_assets/images/trash.png";
import { Loader } from "../_components/loader.component";

export const MANAGE_GROUP_ROUTE = "/manage-community-group/:orgId/:groupId";

let timezones = [];
Timezones.map((timezone) => {
  timezone.utc.map((utc) => {
    timezones.push(utc);
  });
});

timezones = timezones.sort();

let fileUploaded = null;

function ManageGroupPageComponent({ user, history, addToast }) {
  const { groupId, orgId } = useParams();

  // ---------------------------------------------------
  const hiddenFileInput = useRef(null);
  const sp = new URLSearchParams(window.location.search);
  const tab = sp.get("tab");

  const [groupImgUrl, setGroupImgUrl] = useState(null);
  const [groupImg, setGroupImg] = useState(null);
  const [groupImageName, setGroupImageName] = useState("");
  const [groupName, setGroupName] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  // const [orgName, setOrgName] = useState("");
  // const [country, setCountry] = useState("India");
  // const [website, setWebsite] = useState("");
  // const [timezone, setTimezone] = useState("Asia/Kolkata");
  // const [description, setDescription] = useState("");

  const [groupFor, setSessionFor] = useState([
    { label: "Physicians", value: "physicians" },
    { label: "Nurses (non-clinical)", value: "nursesNonClinical" },
    { label: "Nurses (clinical)", value: "nursesClinical" },
    { label: "Allied Health", value: "alliedHealth" },
    { label: "Auxiliary Staff", value: "auxiliaryStaff" },
    { label: "Administrative Staff", value: "administrativeStaff" },
    { label: "Other", value: "other" },
  ]);
  const [rule, setRule] = useState("");
  const [rules, setRules] = useState([]);
  const [rulesError, setRulesError] = useState(undefined);
  const [imageError, setImageError] = useState(undefined);
  const [isEdit, setIsEdit] = useState(false);
  const [btnIsLoading, setBtnIsLoading] = useState(false);

  const [organizations, setOrganizations] = useState([]);
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
  } = useForm();
  // ---------------------------------------------------

  useEffect(() => {
    getAllOrganizations();
  }, []);

  useEffect(() => {
    getGroupDate(groupId);
  }, [organizations]);

  const getGroupDate = (id) => {
    CommunityService.getGroupDetails(user, id)
      .then((resp) => {
        setGroupImg(resp.groupLogo);
        setRules(resp.rules);
        setSelectedOrganizations(
          organizations.filter((org) => resp.organizations.includes(org._id))
        );
        setGroupName(resp.name);
        reset({
          name: resp.name,
          description: resp.description,
          profession: resp.profession,
          organizations: organizations.filter((org) =>
            resp.organizations.includes(org._id)
          ),
        });
        setIsLoading(false);
      })
      .catch((error) => {
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
        console.log(error);
      });
  };

  const getAllOrganizations = () => {
    setIsLoading(true);
    OrganizationService.getAllOrganizations(user)
      .then((resp) => {
        setOrganizations(resp);
      })
      .catch((error) => {
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const submitForm = (data) => {
    setIsSubmitted(true);
    if (!groupImg || rules.length <= 0) {
      if (!groupImg) setImageError("Group image is required.");
      if (rules.length <= 0) setRulesError("Rules are required.");
      return;
    }
    setBtnIsLoading(true);
    if (groupImageName) {
      const formData = new FormData();
      formData.append("file", fileUploaded, fileUploaded.name);
      // setIsLoading(true);
      OrganizationService.uploadImage(user, formData)
        .then((resp) => {
          setGroupImgUrl(resp.url);
          addOrganizationFinal(resp.url, data);
        })
        .catch((error) => {
          addToast("Unable to upload group image", "", ToastTypes.danger);
          console.log(error);
          return;
        });
    } else {
      addOrganizationFinal(groupImg, data);
    }
  };

  const addRule = () => {
    setRules([...rules, rule]);
    setRule("");
  };

  const removeRule = (index) => {
    let allRules = rules;
    allRules.splice(index, 1);
    setRules([...allRules]);
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleChange = (event) => {
    fileUploaded = event.target.files[0];
    setGroupImageName(fileUploaded.name);
    setGroupImg(URL.createObjectURL(fileUploaded));
    setImageError("");
  };

  const addOrganizationFinal = (imgUrl, data) => {
    let groupData = {
      name: data.name,
      description: data.description,
      rules,
      organizations: data.organizations.map((item) => item._id),
      profession: data.profession,
      groupLogo: imgUrl,
    };
    CommunityService.updateGroup(user, groupId, groupData)
      .then((resp) => {
        setBtnIsLoading(false);
        history.push({
          pathname: `/community`,
          search: "?orgId=" + orgId,
        });
        addToast("Group updated successfully", "", ToastTypes.success);
      })
      .catch((error) => {
        setBtnIsLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
        console.log(error);
      });
  };

  const handleDelete = (event) => {
    setGroupImg(null);
    setGroupImgUrl(null);
    setGroupImageName("");
    fileUploaded = null;
  };

  return (
    <div className="page-container ml-auto px-9 py-6 create-org-container">
      <div className="flex pb-4 back-btn-container items-center cursor-pointer">
        <img
          src={leftIcon}
          alt=""
          onClick={() =>
            history.push({
              pathname: `/community`,
              search: "?orgId=" + orgId,
            })
          }
        />
        <span
          className="ml-3 text-xl home-text t-grey"
          onClick={() =>
            history.push({
              pathname: `/community`,
              search: "?orgId=" + orgId,
            })
          }>
          Community Management
        </span>
      </div>
      <div>
        <div className="bg-white card px-11 py-9 relative rounded-lg w-96 w-full">
          {!isLoading ? (
            <div>
              <div className="flex justify-between">
                {isEdit ? (
                  <span className="font-bold text-xl text-primary">
                    Edit Peer Support Group Details
                  </span>
                ) : (
                  <span className="font-bold text-xl text-primary">
                    Peer Support Group Details
                  </span>
                )}
                {!isEdit ? (
                  <Button
                    label="Edit Group"
                    onClick={() => setIsEdit(true)}
                    className="btn-primary"
                  />
                ) : (
                  <></>
                )}
              </div>
              <form onSubmit={handleSubmit((data) => submitForm(data))}>
                <div className="mx-8 my-6 pb-16">
                  <div className="flex general-info-container mt-8 w-full">
                    <div className="image-pick-container">
                      <div
                        className="show-img border flex items-center rounded-md"
                        style={{ backgroundColor: !groupImg ? "#F4FAFF" : "" }}>
                        {/* <img src={groupImgUrl} alt="" className="h-full w-full rounded-md" /> */}
                        {groupImg ? (
                          <img
                            src={groupImg}
                            alt=""
                            className="h-full w-full object-contain rounded-md"
                          />
                        ) : (
                          <div className="w-full">
                            <img
                              src={galleryIcon}
                              alt=""
                              className="h-10 object-contain w-full text-center flex"
                            />
                            <div className="text-xs text-center w-9/12 m-auto mt-2 t-grey">
                              Upload an image for Group.
                            </div>
                          </div>
                        )}
                      </div>
                      {isEdit ? (
                        <>
                          <div className="text-xxs mt-2 pb-2 t-grey">
                            (Upload file below 20MB)
                          </div>
                          <div className="flex w-full items-center">
                            <input
                              type="file"
                              className="hidden"
                              id="my-file"
                              ref={hiddenFileInput}
                              onChange={handleChange}
                              accept="image/gif, image/jpeg, image/png"
                            />
                            <div
                              onClick={handleClick}
                              className="border py-1 flex items-center rounded-md overflow-hidden cursor-pointer justify-center w-full">
                              <img
                                src={uploadIcon}
                                alt=""
                                className="h-5 w-5 rounded-md"
                              />
                              <div
                                className={`flex pl-2 t-grey ${
                                  groupImageName ? "mr-2 pr-2 border-r" : ""
                                } `}>
                                Choose a file
                              </div>
                              {groupImageName ? (
                                <div className="z-10 w-20 overflow-x-scroll whitespace-nowrap mostly-customized-scrollbar t-grey">
                                  {groupImageName}
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                            {groupImg ? (
                              <div
                                className="ml-2 rounded cursor-pointer"
                                onClick={() => handleDelete()}>
                                <img
                                  src={trashIcon}
                                  alt=""
                                  className="h-5 w-5 rounded-md"
                                />
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                          {isSubmitted && imageError ? (
                            <p className={`text-red-500 text-xs h-2.5 w-2/3`}>
                              {imageError}
                            </p>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="ml-20 w-9/12">
                      <div className="border-b flex mb-2 pb-2">
                        <p
                          htmlFor="groupName"
                          className="text-base t-grey w-1/3">
                          Group Name
                        </p>
                        <div className="w-2/3">
                          {!isEdit ? (
                            <>
                              <p className="overflow-auto whitespace-nowrap t-grey">
                                {groupName}
                              </p>
                            </>
                          ) : (
                            <>
                              <input
                                type="text"
                                id="name"
                                placeholder="Enter Group Name"
                                className="py-2 items-center t-grey my-0 border p-1 rounded w-full"
                                {...register("name", {
                                  required: "Group Name is required",
                                })}
                                disabled={!isEdit ? true : false}
                              />
                              <p className={`text-red-500 text-xs h-2.5`}>
                                {errors.name?.message}
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="border-b flex mb-2 mt-2 pb-2 pt-2">
                        <p
                          htmlFor="description"
                          className="text-base t-grey w-1/3">
                          Description
                        </p>
                        <div className="block w-2/3">
                          <textarea
                            type="text"
                            rows={6}
                            id="description"
                            // value={description}
                            placeholder="Enter Description"
                            className="border items-center p-2 rounded t-grey w-full"
                            {...register("description", {
                              required: "Description is required",
                            })}
                            disabled={!isEdit ? true : false}
                          />
                          <p className={`text-red-500 text-xs h-2.5`}>
                            {errors.description?.message}
                          </p>
                        </div>
                      </div>
                      <div className="border-b flex mb-2 mt-2 pb-4 pt-2 justify-between">
                        <p htmlFor="groupFor" className="t-grey text-base w-48">
                          Who is the Group for ? (optional)
                        </p>
                        <Controller
                          name="profession"
                          {...register("profession")}
                          render={({ field }) => (
                            <Select
                              {...field}
                              isMulti
                              options={isEdit ? groupFor : []}
                              className="w-2/3"
                              // isDisabled={type === "details" ? true : false}
                              isClearable={!isEdit ? false : true}
                              placeholder="Who is the group for?"
                              styles={{
                                valueContainer: (base) => ({
                                  ...base,
                                  overflowX: "auto",
                                  flexWrap: "unset",
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  flex: "0 0 auto",
                                }),
                                multiValueRemove: !isEdit
                                  ? (base) => ({
                                      ...base,
                                      display: "none",
                                    })
                                  : undefined,
                              }}
                              components={
                                !isEdit
                                  ? {
                                      DropdownIndicator: () => null,
                                      IndicatorSeparator: () => null,
                                    }
                                  : {}
                              }
                            />
                          )}
                          control={control}
                          defaultValue=""
                        />
                      </div>
                      <div className="border-b mb-2 mt-2 pb-4 pt-2">
                        <div className="flex w-full">
                          <p
                            htmlFor="groupRules"
                            className="text-base t-grey w-1/3">
                            Group Rules
                          </p>
                          {isEdit ? (
                            <div className="flex justify-between w-2/3">
                              <input
                                type="text"
                                id="rules"
                                value={rule}
                                placeholder="Enter Group Rules"
                                onChange={(e) => {
                                  setRule(e.target.value);
                                }}
                                className="py-2 items-center t-grey my-0 border p-1 rounded"
                                style={{
                                  width: "80%",
                                }}
                              />
                              <Button
                                type="button"
                                label="Add Rule"
                                className="btn-primary px-2"
                                disabled={
                                  rule.trim().length <= 0 || rules.length === 8
                                }
                                onClick={() => addRule()}
                              />
                            </div>
                          ) : !isEdit ? (
                            <div className="ml-auto w-2/3 mt-2">
                              {rules.map((r, ind) => {
                                return (
                                  <div
                                    className="flex items-center justify-between w-4/5"
                                    key={ind}>
                                    <span className="mb-2 overflow-x-auto t-grey w-11/12 whitespace-nowrap">
                                      {ind + 1}. {r}
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                        {rules.length > 0 && isEdit ? (
                          <div className="ml-auto w-2/3 mt-2">
                            {rules.map((r, ind) => {
                              return (
                                <div
                                  className="flex items-center justify-between w-4/5"
                                  key={ind}>
                                  <span className="mb-2 overflow-x-auto t-grey w-11/12 whitespace-nowrap">
                                    {ind + 1}. {r}
                                  </span>
                                  <img
                                    src={closeIcon}
                                    alt="close"
                                    className="h-3 cursor-pointer"
                                    onClick={() => removeRule(ind)}
                                  />
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <>
                            {isSubmitted && rulesError ? (
                              <p
                                className={`text-red-500 text-xs h-2.5 ml-auto w-2/3`}>
                                {rulesError}
                              </p>
                            ) : (
                              <></>
                            )}
                          </>
                        )}
                      </div>
                      <div className="flex mb-2 mt-2 pt-2">
                        <p htmlFor="org" className="text-base t-grey w-1/3">
                          Which Organizations
                        </p>
                        <div className="w-2/3">
                          <Controller
                            name="organizations"
                            {...register("organizations", {
                              required: "Organization is required",
                            })}
                            render={({ field }) => (
                              <Select
                                {...field}
                                isMulti
                                options={
                                  !isEdit
                                    ? selectedOrganizations
                                    : organizations
                                }
                                getOptionLabel={(options) => options.name}
                                getOptionValue={(options) => options._id}
                                placeholder="Select Organization"
                                isClearable={!isEdit ? false : true}
                                styles={{
                                  valueContainer: (base) => ({
                                    ...base,
                                    overflowX: "auto",
                                    flexWrap: "unset",
                                  }),
                                  multiValue: (base) => ({
                                    ...base,
                                    flex: "0 0 auto",
                                  }),
                                  multiValueRemove: !isEdit
                                    ? (base) => ({
                                        ...base,
                                        display: "none",
                                      })
                                    : undefined,
                                }}
                                components={
                                  !isEdit
                                    ? {
                                        DropdownIndicator: () => null,
                                        IndicatorSeparator: () => null,
                                      }
                                    : {}
                                }
                              />
                            )}
                            control={control}
                            defaultValue=""
                          />
                          <p className={`text-red-500 text-xs h-2.5`}>
                            {errors.organizations?.message}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {isEdit ? (
                  <div className="mx-8 my-6">
                    <Button
                      label="Cancel"
                      type="button"
                      className={`btn-primary-lite px-14 rounded-lg mr-4 ${
                        btnIsLoading ? "hidden" : ""
                      }`}
                      onClick={() =>
                        history.push({
                          pathname: `/community`,
                          search: "?orgId=" + orgId,
                        })
                      }
                      style={{
                        background: "#adbaf9",
                      }}
                    />
                    <Button
                      type="submit"
                      isLoading={btnIsLoading}
                      label="Save"
                      className="btn-primary px-14 rounded-lg"
                    />
                  </div>
                ) : (
                  <></>
                )}
              </form>
            </div>
          ) : (
            <Loader />
          )}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth,
});

const ManageGroupPage = withToast(
  connect(mapStateToProps)(ManageGroupPageComponent)
);

export default ManageGroupPage;
